const resolveBlacklistUrls = ({ rawVal = [] }) => {
  if (!rawVal.length) return [];

  return rawVal.map(({ emailBlacklistUrl = '' }) => emailBlacklistUrl?.trim());
};

export default resolveBlacklistUrls;
